export const citiesMixin = {
    computed: {
        ethiopiaCities() {
            return [
                {
                    city: this.$t('cities.ADDISABABA.NAME'),
                    neighborhoods: [
                        this.$t('cities.ADDISABABA.neighborHood.PIASA'),
                        this.$t('cities.ADDISABABA.neighborHood.ARATKILO'),
                        this.$t('cities.ADDISABABA.neighborHood.KASANCHIS'),
                        this.$t('cities.ADDISABABA.neighborHood.BOLE'),
                        this.$t('cities.ADDISABABA.neighborHood.MEXICO'),
                        this.$t('cities.ADDISABABA.neighborHood.LAFTO'),
                        this.$t('cities.ADDISABABA.neighborHood.KERA'),
                    ],
                },
                {
                    city: this.$t('cities.DIREDAWA.NAME'),        
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.MEKELE.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.BAHIRDAR.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.GONDER.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.DESSIE.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.AWASA.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.JIMMA.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.BISHOFTU.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.HARAR.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.DEBREBIRHAN.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.JIGJIGA.NAME'),
                    neighborhoods: [],
                },
                {
                    city: this.$t('cities.SHASHEMANAE.NAME'),
                    neighborhoods: [],
                },
            ]
        },
    }
}